import { useEffect, useState } from 'react';

/**
 * One-shot traffic light flash overlay (red → amber → green → fade).
 * Mount once and it auto-unmounts after ~1.4s via onDone callback.
 */
export default function TrafficLightFlash({ onDone }) {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const t = setTimeout(() => {
            setVisible(false);
            onDone && onDone();
        }, 1400);
        return () => clearTimeout(t);
    }, [onDone]);

    if (!visible) return null;
    return (
        <div className="traffic-light-overlay" data-testid="traffic-light-flash" aria-hidden="true" />
    );
}
